var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormControl, Select, InputLabel, MenuItem } from '@mui/material';
import { inject, observer } from 'mobx-react';
var CustomFieldDropdown = /** @class */ (function (_super) {
    __extends(CustomFieldDropdown, _super);
    function CustomFieldDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.field.value
        };
        return _this;
    }
    Object.defineProperty(CustomFieldDropdown.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var options = (_a = this.props.field.options) === null || _a === void 0 ? void 0 : _a.map(function (o, index) {
                var _a;
                return _jsx(MenuItem, __assign({ value: o.value }, { children: (_a = _this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel(o.name, o.value) }), index);
            });
            var labelId = 'idCustomFieldDropdownLabel' + this.props.fieldsStore.fields.indexOf(this.props.field);
            return (_jsxs(FormControl, __assign({ fullWidth: true, variant: "outlined", required: this.props.field.isMandatory, error: this.props.field.isMandatory && !this.props.field.value }, { children: [_jsx(InputLabel, __assign({ id: labelId }, { children: this.props.label }), void 0), _jsxs(Select, __assign({ labelId: labelId, value: this.props.field.value, label: this.props.label, onChange: function (e) { return _this.onValueChanged(e); } }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: "\u00A0" }), -1), options] }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldDropdown.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldValue(this.props.field, e.target.value);
        }
    });
    CustomFieldDropdown = __decorate([
        inject('fieldsStore'),
        inject('languageStore'),
        observer
    ], CustomFieldDropdown);
    return CustomFieldDropdown;
}(React.Component));
export default CustomFieldDropdown;
